import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Education } from "@/components/Education";
import { Clubs } from "@/components/Clubs";
import { Highlights } from "@/components/Highlights";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Portfolio() {
  return (
    <main data-testid="portfolio-page" className="min-h-screen bg-white text-[#0a0a0a]">
      <Navbar />
      <Hero />
      <Education />
      <Clubs />
      <Highlights />
      <Contact />
      <Footer />
    </main>
  );
}
